module.exports = __webpack_public_path__ + "img/799.eef8ce12.png";